module.exports = __webpack_public_path__ + "static/oleksiak-d039358cd38ae3bb8a15e3153cea8a3a.jpg";